import TextLink from 'components/TextLink'
import React from 'react'
import styled from 'styled-components'

import { topCategorySlugs } from '@aboutyou/legacy-shared/src/localizedUrls'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { translateGender } from 'helpers/translateGender'
import { useLocale } from 'store/features/locale/useLocale'
import { white } from 'uiComponents/constants/colors'

const GenderSwitchContainer = styled.div`
  text-align: center;
  margin-bottom: auto;
  a:not(:last-child) {
    margin-right: 40px;
  }
  a:hover {
    text-decoration: underline;
  }
`

const StyledTextLink = styled(TextLink)`
  color: ${white};
  font-weight: bold;
  font-size: 23px;
`

const GenderSwitch: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const { locale } = useLocale()
  const { female, male, children } = topCategorySlugs(locale)

  let kidsUrl = `/c/${children}-138113?sale=true`

  if (
    [
      'en_DE',
      'de_DE',
      'de_AT',
      'en_AT',
      'de_CH',
      'fr_CH',
      'it_CH',
      'en_CH',
    ].includes(locale)
  ) {
    kidsUrl = `/c/${children}/black-friday-530320`
  }

  return (
    <GenderSwitchContainer>
      <StyledTextLink
        to={`/c/${female}/black-friday-341495`}
        title={translateGender(t, 'female')}
        text={translateGender(t, 'female')}
      />
      <StyledTextLink
        to={`/c/${male}/black-friday-342890`}
        title={translateGender(t, 'male')}
        text={translateGender(t, 'male')}
      />
      <StyledTextLink
        to={kidsUrl}
        title={translateGender(t, 'kids')}
        text={translateGender(t, 'kids')}
      />
    </GenderSwitchContainer>
  )
}

export default GenderSwitch
